export default "__VITE_ASSET__dfa556bd__"